"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var primitives_1 = require("../../primitives");
exports.default = {
    sm: primitives_1.borderRadius.sm,
    md: primitives_1.borderRadius.md,
    lg: primitives_1.borderRadius.lg,
    xl: primitives_1.borderRadius.xl,
    base: primitives_1.borderRadius.md,
    full: primitives_1.borderRadius.pill,
};
